export default "<p>mini-task works!</p>\n"